import http from '@/utils/http';

/**
 * 获取用户统计信息
 * @returns {AxiosPromise}
 */
export const getUserTotal = () => {
    return http({
        url: '/api/area/v2/userInfo/total',
    });
};













// 资源教室数量
export const classroomNum = (params)=>{
    return http({
        url:'/api/visual/v2/index/classroom',
        method:'get',
        params
    })
}
//  资源设备数量
export const deviceNum = (params) =>{
    return http({
        url:'/api/visual/v2/index/device',
        params
    })
}






// 教师统计
export const teacherList = (params)=>{
    return http({
        url:'/api/visual/v2/index/teacher',
        params
    })
}


// 设施增加情况 2022年
export const schoolDevice = (params)=>{
    return http({
        url:'/api/visual/v2/index/device',
        params
    })
}

//学生障碍类型占比（分学段）
export const studentDisability = (params)=>{
    return http({
        url:'/api/visual/v2/index/studentDisability',
        params
    })
}
//学生障碍类型占比
export const studentObstacle = (params)=>{
    return http({
        url:'/api/visual/v2/index/studentDisability/all',
        params
    })
}
//  融合学生人数
export const studentNumA = (params)=>{
    return http({
        url:'/api/visual/v2/index/student/all',
        params
    })
}










